import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '@clerk/clerk-react';
import { checkUser } from '../api/AuthService';

export const useUserData = () => {
  const { user: clerkUser } = useUser(); // Renommez pour éviter la confusion
  const navigate = useNavigate();
  
  const [role, setRole] = useState(null);
  const [domains, setDomains] = useState([]);
  const [selectedDomain, setSelectedDomain] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [userData, setUserData] = useState(null); // Nouvel état pour stocker les données de checkUser

  useEffect(() => {
    if (!clerkUser) return;

    const fetchData = async () => {
      try {
        setLoading(true);
        const email = clerkUser.emailAddresses[0]?.emailAddress;
        const userDataResponse = await checkUser(email);
        // console.log("Données utilisateur récupérées :", userDataResponse);

        // Stocker les données complètes de l'utilisateur
        setUserData(userDataResponse);

        if (userDataResponse?.domains) {
          setDomains(userDataResponse.domains);
          sessionStorage.setItem("domains", JSON.stringify(userDataResponse.domains));
        }
        
        if (userDataResponse?.isAdmin) {
          setRole("admin");
          setSelectedDomain(null);
          sessionStorage.removeItem("selectedDomain");
        } else {
          // Vérifier si un domaine est stocké en session
          const storedDomain = sessionStorage.getItem("selectedDomain");
          if (storedDomain) {
            const domainObj = JSON.parse(storedDomain);
            if (domainObj) {
              setSelectedDomain(domainObj);
              setRole(domainObj.role);
            }
          } else if (userDataResponse?.domains?.length > 0) {
            // Prendre le premier domaine par défaut
            const firstDomain = userDataResponse.domains[0];
            setSelectedDomain(firstDomain);
            setRole(firstDomain.role);
            sessionStorage.setItem("selectedDomain", JSON.stringify(firstDomain));
          } else {
            setRole("manager");
          }
        }
      } catch (error) {
        // console.error("Erreur lors de la récupération des domaines et du rôle :", error);
        setError(error.message);
        setRole("manager");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [clerkUser]);

  // Fonction pour changer de domaine
  const changeDomain = (domain) => {
    setSelectedDomain(domain);
    setRole(domain.role);
    sessionStorage.setItem("selectedDomain", JSON.stringify(domain));
  };

  // Fonction pour récupérer les informations complètes de l'utilisateur
  const getUserInfo = () => {
    return {
      ...userData, // Inclut toutes les données de checkUser (accountId, etc.)
      clerkUser, // Données de Clerk
      role,
      domains,
      selectedDomain,
      isAdmin: role === 'admin',
      isValidator: selectedDomain?.isValidator || false,
      isValidationManager: selectedDomain?.isValidationManager || false,
    };
  };

  return {
    // États
    role,
    domains,
    selectedDomain,
    loading,
    error,
    userData, // Les données de checkUser (contient accountId)
    
    // Fonctions
    getUserInfo,
    changeDomain,
    
    // Propriétés calculées (pour faciliter l'accès)
    isAdmin: role === 'admin',
    isValidator: selectedDomain?.isValidator || false,
    isValidationManager: selectedDomain?.isValidationManager || false,
    accountId: userData?.accountId, // accountId vient de userData maintenant
    clerkUserData: clerkUser // Données de Clerk
  };
};